import type { IPostSchema } from './types';

const KLAVIYO_URL = 'https://www.klaviyo.com';

const PostSchema = ({
  authors,
  description,
  excerpt = '',
  featuredImageUrl,
  glossaryTerm,
  mentions,
  publishDate,
  dateModified,
  shortTitle,
  title,
  url,
}: IPostSchema) => {
  const authorItems = authors?.map((author) => {
    const authorUrl = `${KLAVIYO_URL}/blog/author/${author.name?.replaceAll(' ', '-')}`;

    return {
      '@type': 'Person',
      name: author.name,
      url: authorUrl, // author archive page url
    };
  });

  const createMentions = (m: string[] | undefined) => (
    (m && Array.isArray(m)) ? m?.map((mention) => {
      const splitName = mention.split('/');
      const name = splitName[splitName.length - 1].split('-').map((word)=>word?.[0]?.toUpperCase() + word.substring(1, word.length)).join(' ');

      return {
        '@type': 'Thing',
        'name': name,
        'url': mention,
      };
    }) : undefined
  );

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': KLAVIYO_URL + url, // url of post
    },
    headline: title, // page title
    description, // meta description
    image: [
      KLAVIYO_URL + featuredImageUrl, // blog's "featured image"
    ],
    author: authorItems,
    publisher: {
      '@type': 'Organization',
      name: 'Klaviyo',
      url: KLAVIYO_URL,
      logo: {
        '@type': 'ImageObject',
        url: `${KLAVIYO_URL}/static/klaviyo-social-share-image.jpg`, // Klaviyo logo
      },
    },
    datePublished: publishDate,
    dateModified: dateModified,
    mentions: createMentions(mentions),
  };

  if (glossaryTerm) {
    /* @ts-ignore: keywords can be added to schema */
    schema.keywords = [
      {
        '@type': 'DefinedTerm',
        '@id': KLAVIYO_URL + url,
        name: shortTitle,
        description: excerpt.replace(/(<([^>]+)>)/ig, '').replace('\n', ''),
        inDefinedTermSet: 'https://www.klaviyo.com/glossary',
      },
    ];
  }

  return (
    <script id="meta-post-schema" type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  );
};

export default PostSchema;
